import { action } from 'typesafe-actions';
import {
  IIntermediateTransactionInfo,
  IIntermediateTransaction,
} from './../reducers/transactions';

const entity = 'transactions';

const ACTION_ADD_TRANSACTION = `${entity}/APPEND_TRANSACTION`;
const ACTION_UPDATE_TRANSACTION_STATUS = `${entity}/UPDATE_TRANSACTION_STATUS`;
const ACTION_CLEAR_TRANSACTION_STATUSES = `${entity}/CLEAR_TRANSACTION_STATUSES`;

const actionAppendTransaction = (data: IIntermediateTransaction) =>
  action(ACTION_ADD_TRANSACTION, data);
const actionUpdateTransactionStatus = (data: {
  tx: string;
  info: IIntermediateTransactionInfo;
}) => action(ACTION_UPDATE_TRANSACTION_STATUS, data);
const actionClearTransactionStatuses = () =>
  action(ACTION_CLEAR_TRANSACTION_STATUSES);

export {
  ACTION_ADD_TRANSACTION,
  ACTION_UPDATE_TRANSACTION_STATUS,
  ACTION_CLEAR_TRANSACTION_STATUSES,
  actionAppendTransaction,
  actionUpdateTransactionStatus,
  actionClearTransactionStatuses,
};
